import { React } from "react";

import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

import { IoMdAddCircleOutline, IoMdNotificationsOutline } from "react-icons/io";
import { TbIcons } from "react-icons/tb";
import { BsArrowBarRight, BsArrowBarLeft, BsListUl } from "react-icons/bs";
import { CgHome } from "react-icons/cg";
import { BiUserCircle } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import {
  AiOutlineSearch,
  AiOutlineUserAdd,
  AiOutlineUserDelete,
  AiOutlinePlus,
  AiOutlineTable,
  AiOutlineIdcard,
} from "react-icons/ai";
import {
  MdOutlineExitToApp,
  MdHearingDisabled,
  MdOutlineAddAPhoto,
  MdNavigateNext,
  MdNavigateBefore,
  MdLastPage,
  MdFirstPage,
  MdContrast,
  MdOutlineTextIncrease,
  MdOutlineTextDecrease,
} from "react-icons/md";
import { HiOutlineLockClosed, HiOutlineColorSwatch } from "react-icons/hi";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { GrAttachment } from "react-icons/gr";
import { FaWpforms } from "react-icons/fa";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { ContainerIconesPageStyle } from "./style";

function Icones({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer title="Icones" icon={<TbIcons />} />
        <PageContentContainer>
          <ContainerIconesPageStyle
            iconPlus={<AiOutlinePlus style={{ fontSize: "48px" }} />}
          >
            <Row>
              <Col>
                <h2>Icones</h2>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  Documentação:{" "}
                  <a href="https://react-icons.github.io/react-icons/">
                    React Icons
                  </a>
                </p>
                <p className="mb-4 code-container">
                  <code>npm install react-icons --save</code>
                </p>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>Tamanhos</h3>
                <hr />
                <p>
                  <strong>Padrão de tamanho de icones para tabela: </strong>
                  '24px' <TbIcons style={{ fontSize: "24px" }} />
                </p>
                <p>
                  <strong>Padrão de tamanho de icones para sidebars: </strong>
                  '24px' <TbIcons style={{ fontSize: "24px" }} />
                </p>
                <p>
                  <strong>Padrão de tamanho de icones para header: </strong>
                  '48px' <TbIcons style={{ fontSize: "48px" }} />
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>Modelos pré-definidos</h3>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  <BsArrowBarRight style={{ fontSize: "48px" }} />{" "}
                  BsArrowBarRight
                </p>
                <p>
                  <BsArrowBarLeft style={{ fontSize: "48px" }} /> BsArrowBarLeft
                </p>
                <p>
                  <CgHome style={{ fontSize: "48px" }} /> CgHome
                </p>
                <p>
                  <BiUserCircle style={{ fontSize: "48px" }} /> BiUserCircle
                </p>
                <p>
                  <MdOutlineExitToApp style={{ fontSize: "48px" }} />{" "}
                  MdOutlineExitToApp
                </p>
                <p>
                  <IoMdNotificationsOutline style={{ fontSize: "48px" }} />{" "}
                  IoMdNotificationsOutline
                </p>
                <p>
                  <MdOutlineTextIncrease style={{ fontSize: "48px" }} />{" "}
                  MdOutlineTextIncrease
                </p>
                <p>
                  <HiOutlineColorSwatch style={{ fontSize: "48px" }} />{" "}
                  HiOutlineColorSwatch
                </p>
              </Col>
              <Col>
                <p>
                  <CiEdit style={{ fontSize: "48px" }} /> CiEdit
                </p>
                <p>
                  <RiDeleteBin6Line style={{ fontSize: "48px" }} />{" "}
                  RiDeleteBin6Line
                </p>
                <p>
                  <AiOutlineSearch style={{ fontSize: "48px" }} />{" "}
                  AiOutlineSearch
                </p>
                <p>
                  <MdFirstPage style={{ fontSize: "48px" }} /> MdFirstPage
                </p>
                <p>
                  <MdLastPage style={{ fontSize: "48px" }} /> MdLastPage
                </p>
                <p>
                  <GrAttachment style={{ fontSize: "48px" }} /> GrAttachment
                </p>
                <p>
                  <MdOutlineTextDecrease style={{ fontSize: "48px" }} />{" "}
                  MdOutlineTextDecrease
                </p>
                <p>
                  <TbIcons style={{ fontSize: "48px" }} /> TbIcons
                </p>
              </Col>
              <Col>
                <p>
                  <MdNavigateBefore style={{ fontSize: "48px" }} />{" "}
                  MdNavigateBefore
                </p>
                <p>
                  <MdNavigateNext style={{ fontSize: "48px" }} /> MdNavigateNext
                </p>
                <p>
                  <BsEye style={{ fontSize: "48px" }} /> BsEye
                </p>
                <p>
                  <BsEyeSlash style={{ fontSize: "48px" }} /> BsEyeSlash
                </p>
                <p>
                  <HiOutlineLockClosed style={{ fontSize: "48px" }} />{" "}
                  HiOutlineLockClosed
                </p>
                <p>
                  <MdOutlineAddAPhoto style={{ fontSize: "48px" }} />{" "}
                  MdOutlineAddAPhoto
                </p>
                <p>
                  <AiOutlineTable style={{ fontSize: "48px" }} /> AiOutlineTable
                </p>
                <p>
                  <FaWpforms style={{ fontSize: "48px" }} /> FaWpforms
                </p>
              </Col>
              <Col>
                <p>
                  <MdHearingDisabled style={{ fontSize: "48px" }} />{" "}
                  MdHearingDisabled
                </p>
                <p>
                  <AiOutlineUserAdd style={{ fontSize: "48px" }} />{" "}
                  AiOutlineUserAdd
                </p>
                <p>
                  <AiOutlineUserDelete style={{ fontSize: "48px" }} />{" "}
                  AiOutlineUserDelete
                </p>
                <p>
                  <BsListUl style={{ fontSize: "48px" }} /> BsListUl
                </p>
                <p>
                  <IoMdAddCircleOutline style={{ fontSize: "48px" }} />{" "}
                  IoMdAddCircleOutline
                </p>
                <p>
                  <MdContrast style={{ fontSize: "48px" }} /> MdContrast
                </p>
                <p>
                  <AiOutlineIdcard style={{ fontSize: "48px" }} />{" "}
                  AiOutlineIdcard
                </p>
              </Col>
            </Row>
          </ContainerIconesPageStyle>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default Icones;
